module.exports = __webpack_public_path__ + "img/slika66.e0b018b9.jpg";